import Vue from 'vue';
import routes from './routes';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (from.name === 'AddInvoiceDialog' && to.name === 'UpdateInvoiceDialog') {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'SalesBoard';
  }
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return await middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
